import grogu from "../Components/Shop/img/grogu-toy.webp";
import hoodie from "../Components/Shop/img/hoodie.webp";
import luke from "../Components/Shop/img/luke-figure.webp";
import r2d2 from "../Components/Shop/img/r2d2-lamp.webp";
import comic from "../Components/Shop/img/comic.webp";
import smartwatch from "../Components/Shop/img/smartwatch.webp";
import tshirt from "../Components/Shop/img/t-shirt.webp";
import helmet from "../Components/Shop/img/vader-helmet.webp";
import canvas from "../Components/Shop/img/canvas.webp";
import droid from "../Components/Shop/img/droid.webp";
import costume from "../Components/Shop/img/costume.webp";

const dataShop = [
   {
      id: 1,
      price: 45.99,
      img: hoodie,
      name: "Star Wars Darth Vader hoodie",
      category: "Apparel",
   },

   {
      id: 2,
      price: 65.99,
      img: grogu,
      name: "Grogu 'The Child' toy",
      category: "Collectibles",
   },

   {
      id: 3,
      price: 80.49,
      img: r2d2,
      name: "Star Wars R2-D2 lamp",
      category: "Home Decor",
   },

   {
      id: 4,
      price: 35.99,
      img: luke,
      name: "Luke Skywalker figure",
      category: "Collectibles",
   },

   {
      id: 5,
      price: 130.49,
      img: smartwatch,
      name: "Star Wars smartwatch",
      category: "Tech & Gadgets",
   },

   {
      id: 6,
      price: 54.99,
      img: tshirt,
      name: "Star Wars Darth Vader t-shirt",
      category: "Apparel",
   },

   {
      id: 7,
      price: 95.99,
      img: comic,
      name: "Star Wars comic collection",
      category: "Collectibles",
   },

   {
      id: 8,
      price: 79.99,
      img: helmet,
      name: "Darth Vader helmet replica",
      category: "Collectibles",
   },

   {
      id: 9,
      price: 49.99,
      img: canvas,
      name: "Star Wars wall art",
      category: "Home Decor",
   },

   {
      id: 10,
      price: 77.49,
      img: costume,
      name: "Jedi knight costume",
      category: "Apparel",
   },

   {
      id: 11,
      price: 97.49,
      img: droid,
      name: "BB-8 app-enabled droid",
      category: "Tech & Gadgets",
   },
];

export default dataShop;
